import { Component, createRef } from "react";
import { connect } from "react-redux";

import {set_datapage,getMapStateDefault} from '@ora/recursos/src/redux/actions/DataPageAction'
import { Templates } from "@ora/recursos";

import Swal from 'sweetalert2'
import { Button, 
  Card, 

  Section, 
  Form,
   } from 'react-bulma-components';
import axios from "axios";
import { baseUrl, localUrl } from "@ora/recursos/src/helpers/Url";

class DecomisosCreate extends Component {
  isEdit = false
  idrecurso = 0
  state = {
    tipos: [],
    pais: [],
    idioma: [],
    recurso: [],
    sublinea: [],
    data: null
  }
  constructor (props) {
    super(props)
    console.log(this.props)

    this.props.set_datapage({ titulo: 'Nuevo Decomiso',
    isbackend:true,
    breadcrumb:[
        {name:"Intranet",url:"#"},
        {name:"Config",url:"#"},
        {name:"Nuevo Decomiso",url:"#",active:true},
    ]});
    this.frmCreate = createRef()
    let { idrecurso } = this.props.match.params
    if (idrecurso !== undefined) {
      this.isEdit = true
      this.idrecurso = idrecurso
    }
  
  }
  
  componentDidMount () {
   
    console.log('mounteds')
    axios.get(baseUrl('cites/decomiso')).then(res => {
      if (res.data.success) {
          this.setState({
              idioma: res.data.data.idioma,
              recurso: res.data.data.recurso,
          })
      }
    }).then(success => {

      if (this.isEdit) {
        axios.get(baseUrl('cites/decomiso/' + this.idrecurso)).then(res => {
          if (res.data.success) {
            // this.setState({
            //     data: res.data.data
            // })
            
            this.frmCreate.current.elements.dec_txt_scientificname.value = res.data.data.dec_txt_scientificname
            this.frmCreate.current.elements.dec_txt_commonname.value = res.data.data.dec_txt_commonname
            this.frmCreate.current.elements.dec_txt_description.value = res.data.data.dec_txt_description
            this.frmCreate.current.elements.dec_int_quantity.value = res.data.data.dec_int_quantity
            this.frmCreate.current.elements.dec_txt_unit.value = res.data.data.dec_txt_unit
            this.frmCreate.current.elements.dec_txt_product.value = res.data.data.dec_txt_product
            this.frmCreate.current.elements.dec_txt_type.value = res.data.data.dec_txt_type
            this.frmCreate.current.elements.dec_txt_group.value = res.data.data.dec_txt_group  
            this.frmCreate.current.elements.dec_txt_iscites.value = res.data.data.dec_txt_iscites
            this.frmCreate.current.elements.dec_txt_date.value = res.data.data.dec_txt_date
            this.frmCreate.current.elements.dec_num_latitude.value = res.data.data.dec_num_latitude
            this.frmCreate.current.elements.dec_num_longitud.value = res.data.data.dec_num_longitud
            this.frmCreate.current.elements.rec_int_id.value = res.data.data.rec_int_id

            this.frmCreate.current.elements.lan_txt_language.value = res.data.data.lan_txt_language
            
            
        }
        })
      }
    })

  }
  componentDidUpdate () {
    console.log('update')
  }
  onClick_regresar = evt => {
    this.props.history.push(localUrl('/config/decomisos'))
  }
  OnSubmit_create = evt => {
    evt.preventDefault()
    let data = new FormData(this.frmCreate.current)
    axios({
      method: this.isEdit ? 'put' : 'post',
      url: baseUrl('cites/decomiso' + (this.isEdit ? `/${this.idrecurso}` : '')), 
      data: this.isEdit ? Object.fromEntries(data)  : data
    }).then(res => {
      if (res.data.success) {
        this.frmCreate.current.reset()
        Swal.fire(
          'Decomiso',
          res.data.message,
          'success'
        ).then(sr => {
          if (this.isEdit) {
            this.onClick_regresar()
            // this.props.history.push(localUrl('config/recursos'))
          }
        })
      }
    })

  }
 
  COptionLenguaje = () => {
    return this.state.idioma.map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
  COptionRecurso = () => {
    return this.state.recurso.map((item, index) => {
      return <option key={ index } value={ item.id }>{ item.name }</option>
    })

  }
 
  render() {
    return (
      <Templates.Default.BasePageRoute2 
      localUrl={ localUrl }
      dataPage={ this.props.DataPage }
      >
      <div className="is-main-section">
        <Card>
          <Card.Header>
             <Card.Header.Title>
                 <span className="icon"><i className="fas fa-file-invoice"></i></span>Datos
             </Card.Header.Title>
            
          </Card.Header>
          <Card.Content>
            <form  ref={ this.frmCreate }  onSubmit={ this.OnSubmit_create }>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Nombre Cientifico</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix"><input type="text" placeholder="Nombre Cientifico" name="dec_txt_scientificname"
                          required="required" className="input form-control" maxLength="100" />
                      </div>
                      <p className="help">0 / 100 </p>

                    </div>
                  </div>

                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Nombre Comun</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-8">
                      <div className="control   is-clearfix"><input type="text" placeholder="Nombre Comun" name="dec_txt_commonname"
                          required="required" className="input form-control" maxLength="100" />
                      </div>
                      <p className="help">0 / 100 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Descripción</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="control column is-8">
                      <textarea maxLength="400" placeholder="Ingresar descripción" name="dec_txt_description"
                        required="required" className="textarea"></textarea>
                      <small className="help counter"> 0 /
                        400 </small>
                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Cantidad</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-4">
                      <div className="control   is-clearfix"><input type="number" placeholder="Ingresar Cantidad" name="dec_int_quantity"
                          required="required" className="input form-control" maxLength="20" />
                      </div>
                      <p className="help">0 / 20 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Unidad</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-4">
                      <div className="control   is-clearfix"><input type="text" placeholder="Ingresar Unidad" name="dec_txt_unit"
                          required="required" className="input form-control" maxLength="25" />
                      </div>
                      <p className="help">0 / 25 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Producto</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-6">
                      <div className="control   is-clearfix"><input type="text" placeholder="Nombre del Producto" name="dec_txt_product"
                          required="required" className="input form-control" maxLength="50" />
                      </div>
                      <p className="help">0 / 50 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Tipo</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-4">
                      <div className="control   is-clearfix"><input type="text" placeholder="Tipo" name="dec_txt_type"
                          required="required" className="input form-control" maxLength="50" />
                      </div>
                      <p className="help">0 / 50 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Grupo</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-4">
                      <div className="control   is-clearfix"><input type="text" placeholder="Grupo" name="dec_txt_group"
                          required="required" className="input form-control" maxLength="50" />
                      </div>
                      <p className="help">0 / 50 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Cites</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select required="required" name="dec_txt_iscites" disabled={ this.state.idioma.length === 0 }>
                          <option value="-1">- Seleccionar -</option>
                          <option value="Y">SI</option>
                          <option value="N">NO</option>

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Fecha</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-3">
                      <div className="control   is-clearfix"><input type="date" placeholder="Fecha" name="dec_txt_date"
                          required="required" className="input form-control" maxLength="100" />
                      </div>
                   

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Latitud</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-5">
                      <div className="control   is-clearfix"><input type="text" placeholder="Latitud" name="dec_num_latitude"
                          required="required" className="input form-control" maxLength="100" />
                      </div>
                      <p className="help">0 / 50 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Longitud</label></div>
                <div className="field-body">
                  <div className="field columns">
                    <div className="field column is-5">
                      <div className="control   is-clearfix"><input type="text" placeholder="Longitud" name="dec_num_longitud"
                          required="required" className="input form-control" maxLength="100" />
                      </div>
                      <p className="help">0 / 50 </p>

                    </div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Recurso</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select required="required" name="rec_int_id" disabled={ this.state.idioma.length === 0 }>
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionRecurso() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <div className="field is-horizontal">
                <div className="field-label is-normal"><label className="label">Idioma</label></div>
                <div className="field-body">
                  <div className="field">
                    <div className="control"><span className="select is-empty">
                        <select required="required" name="lan_txt_language" disabled={ this.state.idioma.length === 0 }>
                          <option value="-1">- Seleccionar -</option>
                          { this.COptionLenguaje() }

                        </select></span></div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="field is-horizontal">
                <div className="field-label is-normal" />
                <div className="field-body">
                  <div className="field">
                    <div className="field">
                      <div className="field-body">
                        <div className="field is-grouped">
                          <div className="control"><button type="submit"
                              className="button is-primary"><span>Guardar</span></button></div>
                          <div className="control">
                            <button type="button"
                              onClick={ this.onClick_regresar }
                              className="button is-danger"><span>Regresar</span></button></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>


            </form>
          </Card.Content>
        </Card>
      </div>
      </Templates.Default.BasePageRoute2>
    )
  }
}

export default connect(getMapStateDefault(), {set_datapage})(DecomisosCreate)